import { Component, OnInit } from '@angular/core';
import {RedirectToChangePassword} from '../config/utils.config';

@Component({
    selector: 'app-change-password-page',
    templateUrl: './change-password-page.component.html',
    styleUrls: ['./change-password-page.component.scss'],
    standalone: false
})
export class ChangePasswordPageComponent implements OnInit {

  redirectToChangePassword = RedirectToChangePassword;

  constructor() { }

  ngOnInit(): void {
  }

}
